import React from 'react'
import {IntlProvider as IntlProviderOriginal} from 'react-intl'

import {en} from '../../intl/en'

export interface IOwnProps {
}

export type IProps = IOwnProps

const IntlProvider:React.FC<IProps> = (props) => {
  const {
    children,
  } = props

  return (
    // TODO set locale by config
    <IntlProviderOriginal
      locale='en'
      defaultLocale='en'
      messages={{...en}}
    >
      {children}
    </IntlProviderOriginal>
  )
}

export default IntlProvider
